import { Summary } from "../types/scenario-result.type";

const getDecimalPlace = (propertyName: keyof Summary): number => {
  switch (propertyName) {
    case 'carcassYieldPercent':
      return 1;
    case 'feedCostOfHogGrowth':
    case 'feedCostOfGrowth':
    case 'filletFatPercent':
    case 'bFcr':
    case 'globalWarmingPotentialCo2KgPerKgGrowth':
    case 'averageFeedCost':
      return 2;
    case 'finalWeightGrams':
    case 'weightGainGrams':
    case 'feedIntakeGrams':
    case 'hogGainGrams':
      return 0;
    default:
      return 0;
  }
};

export default getDecimalPlace;
